const addResultReducer = (state = {}, action) => {
    switch (action.type) {
      case "ADD_RESULT": {
        return{
          ...state,
          addResultSuccess: action.success
        }
      }
      case "ADD_RESULT_ERR": {
        return{
          ...state,
          addResultError: action.err
        }
      }
      default:
        return state;
    }
  };
  
  export default addResultReducer;
  